import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronDownOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m8 11.5 5-5-.99-.99L8 9.52 3.99 5.51 3 6.5z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChevronDownOutlinedSize16Glyph.displayName = 'ChevronDownOutlinedSize16Glyph';
